import { media } from "src/styles/mixins";
import styled from "styled-components";

const DefaultModalWrapper = styled.div`
  position: relative;
  display: flex;
  margin: auto;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  padding: 30px 15px;

  ${media.up("LAPTOP")`
    justify-content: space-between;
  `}

  width: 100%;
  height: 100%;

  @media ${({ theme }) => theme.mq.md} {
    border: 2px solid ${({ theme }) => theme.colors.primary};
    padding: 60px 120px;
    width: auto;
    height: auto;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: 16px;
  }
`;

export default DefaultModalWrapper;
